import { render, staticRenderFns } from "./ObjectFamilyPhoto.vue?vue&type=template&id=7aaa0f3a&"
import script from "./ObjectFamilyPhoto.vue?vue&type=script&lang=js&"
export * from "./ObjectFamilyPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports